import {Component, Input, ViewChild} from '@angular/core';
import {GritModel} from "../../../models/grit/grit.model";
import {GritFeature} from "../../../models/grit/grit.feature";
import {GritDynamicTableComponent} from "../../../utils/grit/grit-dynamic-table/grit-dynamic-table.component";
import {Subject} from "rxjs";
import {Feature} from "ol";
import {GritDynamicTableMode, GritDynamicTableType} from "../../../models/grit/grit.enums";
import {BsModalRef} from "ngx-bootstrap/modal";
import {
  GritDynamicTableFeaturesComponent
} from "../../../utils/grit/grit-dynamic-table-features/grit-dynamic-table-features.component";

@Component({
  selector: 'app-select-features',
  templateUrl: './select-features.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class SelectFeaturesComponent {
  type : GritDynamicTableType = GritDynamicTableType.EXTENDED;
  @Input() mode : GritDynamicTableMode = GritDynamicTableMode.SELECT_MULTIPLE;
  @Input() features : GritFeature<GritModel<any>>[] = null

  @ViewChild(GritDynamicTableFeaturesComponent) table : GritDynamicTableFeaturesComponent

  public onClose: Subject<GritFeature<any>[]> = new Subject<GritFeature<any>[]>();

  constructor(private bsModalRef : BsModalRef) {}

  ok(){
    this.bsModalRef.hide();

    this.bsModalRef.onHidden.subscribe(() =>{
      this.onClose.next(this.table.selectedFeatures);
      this.onClose.complete();
    })
  }

  cancel(){
    this.bsModalRef.hide();

    this.bsModalRef.onHidden.subscribe(() =>{
      this.onClose.complete();
    })
  }
}
